import { render } from "./Accordion.vue?vue&type=template&id=586ae6f1&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=586ae6f1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586ae6f1"]])

export default __exports__